import { BaseTool } from '../BaseTool';

export class LocationTool extends BaseTool {
    id = 'MANAGE_LOCATION';
    name = 'Location';
    cursor = 'default';

    onActivate(): void {
        this.context?.appStore.openManageDialog('location');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(): void { }
    onPointerMove(): void { }
    onPointerUp(): void { }
}
